"use client";

import type * as React from "react";

import { Button } from "@/components/ui/button";
import { subsectionTitleClassName } from "@/components/ui/typography";
import { cn } from "@/lib/utils";

/** Titled group of fields inside a form or form dialog. */
interface FormSectionProps {
  title?: string;
  children: React.ReactNode;
  className?: string;
}

export function FormSection({ title, children, className }: FormSectionProps) {
  return (
    <div className={cn("flex min-w-0 flex-col gap-3", className)}>
      {title && <h3 className={subsectionTitleClassName}>{title}</h3>}
      {children}
    </div>
  );
}

/** Submit button that swaps to `loadingText` while submitting. */
interface SubmitButtonProps extends React.ComponentProps<typeof Button> {
  loadingText?: string;
  isSubmitting?: boolean;
  canSubmit?: boolean;
}

export function SubmitButton({
  children,
  loadingText = "Salvando...",
  isSubmitting = false,
  canSubmit = true,
  ...props
}: SubmitButtonProps) {
  return (
    <Button disabled={!canSubmit || isSubmitting} type="submit" {...props}>
      {isSubmitting ? loadingText : children}
    </Button>
  );
}
